module.exports = __webpack_public_path__ + "static/media/alertIconSemSobra.b50e80cc.svg";